module.exports = __webpack_public_path__ + "media/t_legis.45f982fe.mp4";